import * as React from 'react'
import { RouterObjects } from '../RouterObjects'
import { MainView } from '../../Views/Main'
import { Main } from '../Main'
import { PageNotFound } from './PageNotFound'

export function Navigated(props): JSX.Element {

  let childs: Object[]

  if (Main.Instance.LoginState.Verified === true) {

    childs = Object.keys(RouterObjects).map(key => {

      if(RouterObjects[key].children && 
        Main.Instance.Location.split('/')[1] == RouterObjects[key].path.replace('/','')) {
        let SelectedChilds = Object.keys(RouterObjects[key].children).map(childKey => {
          if(Main.Instance.Location.split('/')[2] == RouterObjects[key].children[childKey].path.replace('/','')) {

            return React.createElement(RouterObjects[key]. children[childKey].component)
          } else {

              return null
            }
          })

        return React.createElement(RouterObjects[key].component, props, SelectedChilds)

        } else {
          return React.createElement(RouterObjects[key].component, props)
          // return null
        }
      })

    childs = childs.filter(Boolean)

    // was let finalChildren = childs[0] ? childs : PageNotFound()
    let finalChildren = childs[0] ? childs[0] : PageNotFound()
/*
    if (childs && childs.length > 0) {
      for (let i:number = 0; i < childs.length; i++) {
        finalChildren[i].key = i.toString()
      }
    }
*/
    // console.log (finalChildren)

    return React.createElement(MainView, props, finalChildren)
  } else {

    return React.createElement(RouterObjects.index.component, props)
    }
  }


// WEBPACK FOOTER //
// ./src/Logic/Router/Router.ts